import Page from '@aboutyou/legacy-desktop/src/app/pages/BrandsOverview/BrandOverviewPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/BrandsOverview/redial';
import {useSubmitMissionProgress} from '@aboutyou/logic-components';
import {useSearchEventsUtils} from '@aboutyou/tracking';
import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';
import {LegacyDesktopStyles} from '../styles/LegacyBaseStyles';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);
const PageWithProviders = withLegacyProviders(PageWithRedial);

export const BrandsOverview = () => {
  const {updateSearchEventContextParams} = useSearchEventsUtils();
  const submitLikeBrandMission = useSubmitMissionProgress({
    mission: 'likeBrandMission',
  });

  const updateSearchContext = (term: string) => {
    updateSearchEventContextParams({
      searchName: 'searchHotkey',
      searchTerm: term,
    });
  };

  return (
    <>
      <div className={LegacyDesktopStyles} />
      <PageWithProviders
        updateSearchContext={updateSearchContext}
        submitLikeBrandMission={submitLikeBrandMission}
      />
    </>
  );
};
